import { defineStore } from "pinia";
import Services from '@/services/educationDataServices'
import { mapEducationData } from '@/helpers/mapFuncs'

export const useEducationDataStore = defineStore("educationData", {

state:()=>({
    education: {},
    educations: [],
}),
getters : {
    // getEducation() {
    //     // alert('getEducation')
    //     return mapEducationData(this.education)
    // },
    getEducations() {
        return this.educations.map(mapEducationData)
    }
},
actions : {
    /** Start Sets */
    setEducation(education) {
        this.education = education
    },
    setEducations(educations) {
        this.educations = educations
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setEducation(response.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setEducations(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setEducations(response.data.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.educations.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        console.log("edit id, data", id, data);
        return Services.edit(id, data)
        .then((response)=>{
            this.educations[this.educations.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.educations = this.educations.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});